module.exports = __webpack_public_path__ + "img/chris_g_24.dd548ae5.jpg";